<template>
  <main>
    <section class="split">
      <div class="left">
        <div class="marked">
          <h1>{{ $t('views.Contact.pageTitle') }}</h1>
        </div>
        <i18next path="views.Contact.description" tag="p">
          <a place="commonFaqs" href="/faqs">
            {{ $t('views.Contact.commonFaqs') }}
          </a>
        </i18next>

        <form ref="contactForm" @submit.prevent="submitTicket">
          <fieldset :disabled="loading">
            <div class="form-field">
              <label for="name">{{ $t('views.Contact.name') }}</label>
              <input
                id="name"
                v-model="formData.name"
                :placeholder="$t('views.Contact.namePlaceholder')"
                type="text"
                required
              />
            </div>
            <div class="form-field">
              <label for="email">{{ $t('views.Contact.email') }}</label>
              <input
                id="email"
                v-model="formData.email"
                :placeholder="$t('views.Contact.emailPlaceholder')"
                type="email"
                required
              />
            </div>
            <div class="form-field">
              <label for="subject">{{ $t('views.Contact.subject') }}</label>
              <input
                id="subject"
                v-model="formData.subject"
                :placeholder="$t('views.Contact.subjectPlaceholder')"
                type="text"
                required
              />
            </div>
            <div class="form-field other">
              <label for="other">Other</label>
              <input
                id="other"
                v-model="formData.other"
                placeholder="Enter further information"
                type="text"
              />
            </div>
            <div class="form-field">
              <label for="message">{{ $t('views.Contact.message') }}</label>
              <textarea
                id="message"
                v-model="formData.body"
                :placeholder="$t('views.Contact.messagePlaceholder')"
                name="message"
                cols="30"
                rows="6"
                required
              />
            </div>
            <Button
              :isSuccess="success"
              :isLoading="loading"
              type="submit"
              class="btn-primary"
            >
              {{ $t('common.btnSubmit') }}
            </Button>
          </fieldset>
          <Response
            v-if="success || success === false"
            :success="success"
            @reset-success="success = undefined"
          />
        </form>
      </div>
      <div class="right">
        <div class="marked">
          <h2>{{ $t('views.Contact.keepInTouchTitle') }}</h2>
        </div>
        <p>
          {{ $t('views.Contact.keepInTouchText') }}
        </p>

        <div class="social-icons">
          <a href="https://twitter.com/CITC_SA" target="_blank">
            <img src="/img/icon-social-twitter.svg" alt="Twitter" />
          </a>
          <a href="https://www.facebook.com/CST.KSA" target="_blank">
            <img src="/img/icon-social-facebook.svg" alt="Facebook" />
          </a>
          <a href="https://www.linkedin.com/company/citc_sa/" target="_blank">
            <img src="/img/icon-social-linkedin.svg" alt="LinkedIn" />
          </a>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import Button from '@/components/Button';
import Response from './Response';

export default {
  components: {
    Button,
    Response
  },
  metaInfo() {
    return {
      title: 'Get in touch'
    };
  },
  data: () => ({
    loading: false,
    success: undefined,
    formData: {
      name: '',
      email: '',
      subject: '',
      // honeypot
      other: null,
      body: ''
    }
  }),
  methods: {
    submitTicket() {
      // honeypot
      if (this.formData.other !== null) {
        return;
      }

      this.success = undefined;
      this.loading = true;
      const xhr = new XMLHttpRequest();

      xhr.open('POST', 'https://meqyas.zendesk.com/api/v2/requests.json', true);
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          this.loading = false;
          this.success = xhr.status >= 200 && xhr.status < 300;
          if (!this.loading && this.success) {
            this.resetForm();
          }
        }
      };
      const data = {
        request: {
          requester: {
            name: this.formData.name,
            email: this.formData.email
          },
          subject: this.formData.subject,
          comment: {
            body: this.formData.body
          },
          priority: 'low'
        }
      };

      xhr.send(JSON.stringify(data));
    },
    resetForm() {
      this.formData.name = '';
      this.formData.email = '';
      this.formData.subject = '';
      this.formData.body = '';
      this.$refs.contactForm.reset();
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/base/colors';
@import '../../scss/helpers/mixins';

.split {
  margin-top: 20px;
  padding: 0 20px;
}

// honeypot
.other {
  display: none;
}

.right {
  margin-top: 20px;
}

.social-icons {
  display: flex;
  width: 100%;

  > a {
    flex: 1;
    text-align: center;
  }
}

@include breakpoint(M) {
  .split {
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 86px;
    display: flex;
  }

  .left {
    flex: 2;
    padding-right: 40px;

    [dir='rtl'] & {
      padding-right: 0;
      padding-left: 40px;
    }
  }
  .right {
    flex: 1;
    padding-left: 40px;
    margin-top: 0;

    [dir='rtl'] & {
      padding-left: 0;
      padding-right: 40px;
    }
  }
}
</style>
